if (!customElements.get('product-sticky-atc')) {
  customElements.define(
    'product-sticky-atc',
    class ProductStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        if (!this.sectionId) return;

        this.purchasePanel = document.getElementById(`ProductInfo-${this.sectionId}`);
        this.submitBtn = this.querySelector('[data-sticky-atc-submit]');
        this.priceTarget = this.querySelector('[data-sticky-price]');
        this.tabsBoundary = document.querySelector('[data-product-sticky-atc-boundary]');

        if (this.submitBtn) {
          this.submitBtn.addEventListener('click', () => this.submitProductForm());
        }

        this._onScroll = () => {
          if (this._scrollRaf) return;
          this._scrollRaf = window.requestAnimationFrame(() => {
            this._scrollRaf = null;
            this._updateVisibility();
          });
        };

        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onScroll, { passive: true });
        this._updateVisibility();

        this._setupPriceObserver();
        this._syncPrice();
        this._subscribeVariantChange();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onScroll);
        if (this._scrollRaf) window.cancelAnimationFrame(this._scrollRaf);
        this._priceObserver?.disconnect();
        this._unsubscribe?.();
      }

      scrollToProductForm() {
        const formRoot =
          document.getElementById(`product-form-${this.sectionId}`)?.closest('product-form') ||
          this.purchasePanel?.querySelector('product-form, .product-form');

        if (formRoot) {
          formRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else if (this.purchasePanel) {
          this.purchasePanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        const submit = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (submit) {
          window.setTimeout(() => submit.focus({ preventScroll: true }), 400);
        }
      }

      submitProductForm() {
        const submit =
          document.getElementById(`ProductSubmitButton-${this.sectionId}`) ||
          this.purchasePanel?.querySelector('button[name="add"]');

        if (!submit) {
          this.scrollToProductForm();
          return;
        }

        if (submit.disabled) {
          this.scrollToProductForm();
          return;
        }

        submit.click();
      }

      _getHeaderOffset() {
        const header =
          document.querySelector('.shopify-section-group-header-group') ||
          document.querySelector('sticky-header') ||
          document.querySelector('.header-wrapper');
        return (header?.getBoundingClientRect().height || 72) + 12;
      }

      _updateVisibility() {
        const boundary = this.tabsBoundary || document.querySelector('[data-product-sticky-atc-boundary]');

        if (!boundary) {
          this.classList.remove('is-visible');
          this.setAttribute('aria-hidden', 'true');
          return;
        }

        const header = this._getHeaderOffset();
        const { bottom } = boundary.getBoundingClientRect();
        const show = bottom < header;

        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
      }

      _getPriceSource() {
        return document.getElementById(`product-price-display-${this.sectionId}`);
      }

      _syncPrice() {
        if (!this.priceTarget) return;
        const source = this._getPriceSource();
        if (!source) return;
        this.priceTarget.innerHTML = source.innerHTML;
      }

      _setupPriceObserver() {
        const source = this._getPriceSource();
        if (!source || !this.priceTarget) return;

        this._priceObserver = new MutationObserver(() => this._syncPrice());
        this._priceObserver.observe(source, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }

      _subscribeVariantChange() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this._unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event?.data?.sectionId !== this.sectionId) return;
          window.requestAnimationFrame(() => this._syncPrice());
        });
      }
    }
  );
}
